import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import { fetchgastenverbruik, fechgastenprofiel, exportExcel } from "./Reducers/actions";
import Filterreservering from "./Components/filterreservering";
import moment from "moment";

const InschrijvingPage = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const gastenverbruik = useSelector((state) => state.gastenverbruik.gastenverbruik);
  const gastenprofiel = useSelector((state) => state.gastenverbruik.gastenprofielen);
  const user = useSelector((state) => state.auth.user);
  const [querie, setQuerie] = useState(null);
  const { SearchBar } = Search;
  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      try {
        const data = await dispatch(fetchgastenverbruik());
        if (data.type === "GASTEN_VERBRUIK_ERROR") throw new Error("Fout bij ophalen gastenverbruik");

        const profiel = await dispatch(fechgastenprofiel());
        if (profiel.type === "GASTEN_VERBRUIK_ERROR") throw new Error("Fout bij ophalen gastenprofiel");

        setLoading(false);
      } catch (err) {
        console.error(err.message);
        setLoading(false); // altijd weer uit, ook bij fout
      }
    };

    loadData();
  }, [dispatch]);

  const changeform = (values) => {
    const query = {};
    if (values.vertrek?.startdate) {
      query.aankomstVanaf = moment(values.vertrek.startdate).format("YYYY-MM-DD");
    }

    if (values.vertrek?.enddate) {
      query.vertrekTot = moment(values.vertrek.enddate).format("YYYY-MM-DD");
    }

    if (values.gastenprofielValue) {
      query.gastenprofiel = values.gastenprofielValue;
    }

    if (values.meterstandvertrek !== undefined) {
      query.meterstandvertrek = values.meterstandvertrek;
    }

    const queryString = new URLSearchParams(query).toString();
    setQuerie(queryString);

    dispatch(fetchgastenverbruik(queryString));
  };

  const exporttoexcel = async () => {
    setLoading(true);
    try {
      const data = await dispatch(exportExcel(querie));
      if (data.type === "GASTEN_VERBRUIK_ERROR") throw new Error("Fout bij ophalen gastenverbruik");
      setLoading(false);
    } catch (err) {
      console.error(err.message);
      setLoading(false); // altijd weer uit, ook bij fout
    }
  };
  const gastenverbruikMetPlaatsnaam = gastenverbruik.map((item) => ({
    ...item,
    plaatsnaam: item.standplaats?.naam || item.accommodaties?.naam || "",
  }));

  const columns = [
    {
      dataField: "_id",
      text: "_id",
      hidden: true,
    },
    {
      dataField: "plaatsnaam",
      text: "Plaatsnummer",
      sort: true,
    },
    {
      dataField: "gast",
      text: "Naam gast",
      sort: true,
      formatter: (cellContent, row) => {
        if (!cellContent) {
          return <span>Geen gast</span>;
        }
        return (
          <span>
            {cellContent.voornaam} {cellContent.tussennaam} {cellContent.achternaam}
          </span>
        );
      },
    },
    {
      dataField: "gast.email",
      text: "E-Mail",
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "300px" };
      },
    },
    {
      dataField: "aankomst",
      text: "Aankomst",
      sort: true,
      formatter: (cellContent, row) => {
        if (!row.altijdtoegang) {
          return <span>{moment(cellContent).format("DD-MM-YYYY HH:mm")}</span>;
        }
      },
    },
    {
      dataField: "vertrek",
      text: "Vertrek",
      sort: true,
      formatter: (cellContent, row) => {
        if (!row.altijdtoegang && row.vertrek) return <span>{moment(cellContent).format("DD-MM-YYYY HH:mm")}</span>;
      },
    },
    {
      dataField: "gast.gastenprofiel.naam",
      text: "Gastenprofiel",
      sort: true,
      formatter: (cellContent, row) => {
        return <span>{cellContent}</span>;
      },
    },

    {
      text: "Acties",
      dataField: "_id",
      formatter: (cellContent, row) => {
        if (row.standplaats && row.standplaats._id) {
          return (
            <span>
              <Link className="btn btn-primary btn-sm mx-2" to={{ pathname: "/gastenverbruik/kampeerplaats/" + row._id }}>
                Bekijken
              </Link>
            </span>
          );
        } else if (row.accommodaties && row.accommodaties.naam) {
          return (
            <span>
              <Link className="btn btn-primary btn-sm" to={{ pathname: "/gastenverbruik/accommodatie/" + row._id }}>
                Bekijken
              </Link>
            </span>
          );
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "150px" };
      },
    },
  ];
  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title"> Reserveringen</h3>
        {user?.bedrijf?.modules?.includes("accommodaties") && (
          <div className="box-tools pull-right">
            <Link className="btn btn-primary btn-sm" to="/gastenverbruik/insert">
              <i className="fa fa-plus" /> Toevoegen Reservering
            </Link>
          </div>
        )}
      </div>
      <div className="box box-default">
        <div className="row">
          <div className="col-md-12 no-float">
            <div className="box box-primary">
              <Filterreservering gastenprofiel={gastenprofiel} changeform={changeform} exporttoexcel={exporttoexcel} />
              <div className="box-body box-profile" />
              <ToolkitProvider keyField="_id" data={gastenverbruikMetPlaatsnaam} columns={columns} search={{ searchFormatted: true }}>
                {(props) => (
                  <div>
                    <SearchBar placeholder="Zoeken" {...props.searchProps} />
                    <hr />
                    <BootstrapTable wrapperClasses="table-responsive-md" pagination={paginationFactory()} {...props.baseProps} />
                  </div>
                )}
              </ToolkitProvider>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default InschrijvingPage;
